module.exports = __webpack_public_path__ + "img/bbc_radio_cymru_2.882e8bbb.png";